import { render } from "./ProfilePage.vue?vue&type=template&id=679462c2&scoped=true&ts=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"

import "./ProfilePage.vue?vue&type=style&index=0&id=679462c2&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679462c2"]])

export default __exports__